import { z } from "zod";

export const assetUploadOriginEnum = z.enum(["payment_flow", "file_manager"]);
export type AssetUploadOrigin = z.infer<typeof assetUploadOriginEnum>;
